var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIosNavy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "145px",
    height: "44px",
    viewBox: "0 0 145 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Button / Badge / iOS / Mint") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UHC-Employers-(EB)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AA-Adjustments:-Purchase-Confirmation-1440",
    transform: "translate(-634.000000, -505.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window",
    transform: "translate(230.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-Badge-/-iOS-/-Mint",
    transform: "translate(404.000000, 409.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "button",
    fill: "#01313d",
    x: 0,
    y: 0,
    width: 145,
    height: 44,
    rx: 6.79500511
  }), /*#__PURE__*/React.createElement("g", {
    id: "Download-on-the-App-Store",
    transform: "translate(46.206035, 6.115505)",
    fill: "#FFFFFF",
    fontFamily: "SFProDisplay-Medium, SF Pro Display",
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("text", {
    id: "App-Store",
    fontSize: 19.7055148
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 28.5130072
  }, "App Store")), /*#__PURE__*/React.createElement("text", {
    id: "Download-on-the",
    fontSize: 10.1925077,
    letterSpacing: 0.415401
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "Download on the"))), /*#__PURE__*/React.createElement("path", {
    d: "M32.7242161,32.4152936 C31.5318588,34.1512297 30.2984748,35.876488 28.3511396,35.9126504 C26.4346461,35.9488128 25.8202493,34.7825051 23.6333524,34.7825051 C21.4441603,34.7825051 20.7593295,35.876488 18.9498355,35.9488128 C17.0698788,36.0188596 15.6403841,34.073922 14.4382005,32.3458163 C11.9821769,28.8124395 10.1076426,22.3551785 12.6286922,17.9974421 C13.8771098,15.8332951 16.1141281,14.4640226 18.5382772,14.4278745 C20.3844944,14.394047 22.1285608,15.6670621 23.2562221,15.6670621 C24.3856048,15.6670621 26.502498,14.1386609 28.727983,14.3628392 C29.659548,14.4011513 32.2740697,14.7365502 33.9531532,17.1826356 C33.8204618,17.269468 30.8323961,19.0001933 30.8688324,22.6058948 C30.9054122,26.9130609 34.6599319,28.344749 34.7035407,28.3642539 C34.669543,28.4654801 34.1033455,30.4081397 32.7242161,32.4152936 Z M24.5479903,9.63133473 C25.5786793,8.42890745 27.3201637,7.5345437 28.7573903,7.47444867 C28.9410064,9.14468035 28.2660737,10.8172184 27.2692389,12.022422 C26.2703958,13.2254614 24.6353514,14.1626078 23.0307185,14.0374775 C22.8126744,12.403394 23.6214461,10.6991782 24.5479903,9.63133473 Z",
    id: "logo",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosNavy);
export default __webpack_public_path__ + "static/media/ios-navy.2ca36513096ef34b8085734048761433.svg";
export { ForwardRef as ReactComponent };